var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMegaphone1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.894 9.96462L12.5337 0.602864C11.9816 0.052175 11.0886 0.0586906 10.5438 0.60216C9.99583 1.15149 9.99583 2.04343 10.5438 2.59206L19.9055 11.9532C20.4539 12.5016 21.3456 12.5016 21.894 11.9532C22.444 11.4032 22.444 10.5145 21.894 9.96462Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84943 3.88618L9.77898 4.23934C9.28271 6.72175 8.07661 9.08009 6.44531 10.9915L11.5382 16.0843C13.4493 14.4534 15.7752 13.2149 18.2577 12.718L18.6115 12.6476L9.84943 3.88618Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51083 12.0464L2.03021 15.5263C1.20779 16.3487 1.20437 17.6839 2.03021 18.5098L4.01875 20.4983C4.84117 21.3207 6.17636 21.3241 7.00221 20.4983L10.4825 17.018L5.51083 12.0464ZM6.00798 17.5155C5.73334 17.7902 5.28836 17.7902 5.01372 17.5155C4.73908 17.2409 4.73908 16.7959 5.01372 16.5213L6.00798 15.527C6.28263 15.2524 6.72761 15.2524 7.00225 15.527C7.27689 15.8016 7.27689 16.2466 7.00225 16.5213L6.00798 17.5155Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4197 20.8724L14.3762 19.916C15.2021 19.0902 15.1993 17.755 14.3762 16.9332L13.6658 16.2223C13.2731 16.4861 12.8981 16.7726 12.5335 17.0785L13.3819 17.9282C13.6559 18.2007 13.6579 18.6444 13.3819 18.9217L12.4097 19.894L10.9808 18.5097L8.99219 20.4983L12.1824 23.5896C12.7268 24.1354 13.6206 24.1385 14.1702 23.5889C14.7188 23.0402 14.7188 22.1483 14.1702 21.5996L13.4197 20.8724Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2598 0C15.8711 0 15.5566 0.314485 15.5566 0.703126V2.10938C15.5566 2.49802 15.8711 2.81251 16.2598 2.81251C16.6484 2.81251 16.9629 2.49802 16.9629 2.10938V0.703126C16.9629 0.314485 16.6484 0 16.2598 0Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8848 5.62502H20.4785C20.0899 5.62502 19.7754 5.9395 19.7754 6.32814C19.7754 6.71678 20.0899 7.03127 20.4785 7.03127H21.8848C22.2734 7.03127 22.5879 6.71678 22.5879 6.32814C22.5879 5.9395 22.2734 5.62502 21.8848 5.62502Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9756 1.61222C20.701 1.33757 20.256 1.33757 19.9814 1.61222L18.5751 3.01847C18.3005 3.29311 18.3005 3.73809 18.5751 4.01274C18.8498 4.28738 19.2947 4.28742 19.5694 4.01274L20.9756 2.60648C21.2503 2.33184 21.2503 1.88686 20.9756 1.61222Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone1);
export default __webpack_public_path__ + "static/media/megaphone 1.506001d31364b7602549b41da4113736.svg";
export { ForwardRef as ReactComponent };